<template>
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
		<path
			stroke="currentColor"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="1.5"
			d="M7 13V3m0 10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m0 10a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2M7 3a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2m0 10V3m0 10a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-2a2 2 0 0 0-2 2"
		/>
	</svg>
</template>
